import React from 'react'

// Allows unit testing fields separately from context
export const useRealOrMockContext = (SiteWizardContext) => {
  return React.useContext(SiteWizardContext) || SiteWizardContext
}
